import { startingSlots } from './custom';

// Bracket Library → "Manage as Tournament" hands its bracket to the Create Event Wizard.
const KEY = 'sg_bracket_convert';
const CUSTOM_KEY = (id) => `sg_bracket_custom:${id}`;

export function startConversion({ templateId, preview, c, title }) {
  const sourceId = c.sourceId || crypto.randomUUID();
  const stamp = Date.now();
  const teams = startingSlots(preview.teams).map((s, i) => ({
    id: `team_${stamp}_${i}`, name: (c.names[s.key] || '').trim() || `Team ${i + 1}`, seed: i + 1,
  }));
  const draft = {
    templateId, sourceId, shareId: c.shareId || '', format: preview.format, name: c.title.trim() || title, date: c.date || '',
    teams, order: teams.map((t) => t.id),
    scores: Object.entries(c.scores || {}).map(([label, s]) => ({ match_label: label, score_a: s.a, score_b: s.b })),
  };
  try { sessionStorage.setItem(KEY, JSON.stringify(draft)); } catch { /* private mode */ }
  return sourceId;
}

export function readConversion() {
  try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch { return null; }
}

// Scores only carry over while the bracket still has the Library's structure.
export const canImportScores = (draft, eventData) => !!draft?.scores?.length
  && eventData.format === draft.format && !eventData.bracket_positions
  && eventData.teams.map((t) => t.id).join() === draft.order.join();

export function finishConversion(draft, eventId) {
  try {
    const saved = JSON.parse(localStorage.getItem(CUSTOM_KEY(draft.templateId)) || '{}');
    localStorage.setItem(CUSTOM_KEY(draft.templateId), JSON.stringify({ ...saved, sourceId: draft.sourceId, eventId }));
    sessionStorage.removeItem(KEY);
  } catch { /* private mode */ }
}
